import { createMostSpecificTag } from '../cacheTags/CacheTagTypes';
export const provideSpecificCacheTagsFromRelevantAddresses = (chainId, relevantAddresses) => {
    if (relevantAddresses.tokens.length) {
        return relevantAddresses.tokens
            .map((tokenAddress) => [createMostSpecificTag({ chainId, address1: tokenAddress })].concat(relevantAddresses.accounts.map((accountAddress) => createMostSpecificTag({ chainId, address1: tokenAddress, address2: accountAddress }))))
            .flat();
    }
    else if (relevantAddresses.accounts.length) {
        return relevantAddresses.accounts.map((accountAddress) => createMostSpecificTag({ chainId, address1: accountAddress }));
    }
    else {
        return [createMostSpecificTag({ chainId })];
    }
};
//# sourceMappingURL=provideSpecificCacheTagsFromRelevantAddresses.js.map